// extracted by mini-css-extract-plugin
export default {"open":"ScriptStatusIcon_open__XM1RO","limited":"ScriptStatusIcon_limited__eQqVO","private":"ScriptStatusIcon_private__134cx"};